import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Reset window scroll to the top on every route change.
 *
 * React Router 7 does not reset scroll position on navigation by default —
 * the destination page renders at the source page's scroll Y. That means
 * clicking a CTA from far down the homepage lands the user mid-page on the
 * target route, while clicking the same link from a shorter source page
 * happens to land at the top because Y exceeded the destination's height.
 *
 * Mount once inside <BrowserRouter>. Listens for `pathname` changes and
 * scrolls to (0, 0) — instant, not smooth, so the user doesn't see the
 * old page glide away.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}
